import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import InfoBar from './InfoBar.jsx';
import Navbar from './Navbar.jsx';
import Footer from './Footer.jsx';
import AkutHjaelp from '../AkutHjaelp.jsx';

const treatmentTitles = {
  '/adhd': 'ADHD & metakognitiv terapi',
  '/angst': 'Effektiv angstbehandling',
  '/autismevenlig-terapi': 'Autismevenlig terapi',
  '/behandlinger/rygestop': 'Effektivt rygestop',
  '/borderline': 'Borderline-behandling',
  '/depression': 'Depression & metakognitiv terapi',
  '/eksamensangst-praestationsangst': 'Eksamens- & præstationsangst',
  '/flyskraek': 'Hjælp til flyskræk',
  '/generaliseret-angst': 'Generaliseret angst',
  '/helbredsangst': 'Helbredsangst & metakognitiv terapi',
  '/hypnose': 'Klinisk hypnose & terapi',
  '/metakognitiv-terapi': 'Metakognitiv terapi',
  '/ocd': 'OCD & metakognitiv terapi',
  '/online-sessioner': 'Online sessioner',
  '/panikangst': 'Panikangst & metakognitiv terapi',
  '/parterapi': 'Nænsom parterapi',
  '/social-angst': 'Social angst & metakognitiv terapi',
  '/soevnproblemer': 'Søvnproblemer & metakognitiv terapi',
  '/sorg-og-tab': 'Nænsom sorgterapi',
  '/stress': 'Stress & metakognitiv terapi',
  '/tankemylder': 'Få ro på tankemylder',
  '/traume': 'Traume & metakognitiv terapi',
  '/behandlinger': 'Behandlinger hos Core Hypnose'
};

const Layout = ({ children }) => {
  const location = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showStickyBar, setShowStickyBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowStickyBar(true);
      } else {
        setShowStickyBar(false);
      }
      if (window.scrollY > 500) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const showAkut = [
    '/angst',
    '/kontakt'
  ].includes(location.pathname);

  const normalizedPath = location.pathname.length > 1 && location.pathname.endsWith('/') 
    ? location.pathname.slice(0, -1) 
    : location.pathname;

  const isTreatmentPage = Object.keys(treatmentTitles).includes(normalizedPath);
  const currentTreatmentTitle = treatmentTitles[normalizedPath];

  return (
    <div className="min-h-screen flex flex-col bg-[#FAF7F2] text-[#3B352F] selection:bg-[#123F13] selection:text-white overflow-x-clip">
      <InfoBar />
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      {showAkut && (
        <div id="akut" className="px-6 pb-12">
          <AkutHjaelp />
        </div>
      )}
      <Footer />

      {/* Global Sticky Book tid-bar på mobil til alle behandlingssider */}
      <AnimatePresence>
        {isTreatmentPage && showStickyBar && (
          <motion.div
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            exit={{ y: 100 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="fixed bottom-0 left-0 right-0 z-40 bg-[#FAF7F2]/95 backdrop-blur-md border-t border-[#E8DDCE] py-3 px-4 shadow-lg lg:hidden flex items-center justify-between"
          >
            <div className="flex flex-col text-left pr-2 min-w-0">
              <span className="text-[10px] uppercase tracking-wider text-[#8C2F12] font-bold leading-tight">CORE HYPNOSE</span>
              <span className="text-xs font-serif text-[#123F13] font-semibold leading-tight truncate">{currentTreatmentTitle}</span>
            </div>
            <Link
              to="/bestil-tid"
              className="bg-[#123F13] text-white text-xs font-bold px-8 py-3 rounded-lg hover:bg-[#123F13]/90 transition-all shadow-sm text-left leading-tight shrink-0 min-w-[180px]"
            >
              Book første<br />behandlingssession
            </Link>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Global Til toppen-knap på mobil og desktop til alle behandlingssider */}
      <AnimatePresence>
        {isTreatmentPage && showScrollTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className={`fixed ${showStickyBar ? 'bottom-20' : 'bottom-6'} lg:bottom-6 right-6 z-50 w-11 h-11 bg-[#123F13] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#8C2F12] transition-colors border border-[#E8DDCE] cursor-pointer`}
            aria-label="Til toppen"
          >
            <i className="fa-solid fa-arrow-up text-sm" aria-hidden="true" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Layout;
